/*global _ */
const EventBus = window.VueEventBus

import props from './props'
import CartMixin from '../../../../mixins/cart'
import ProductMixin from '../../../../mixins/store/product'
import CartLocationMixin from '../../../../mixins/cart/location'
import ResponsiveMixin from '../../../../mixins/responsive'
import ComponentMixin from '../../../../mixins/components/complex-reactive'
// import nextActionMixinFactory from '../../../../designer/mixins/components/next-action'
//custom-cart-page-navigation
// const NextActionMixin = nextActionMixinFactory(
//   {
//     'customShoppingPageNavigation': true,
//     'customCartPageNavigation': true
//   },
//   {
//     customNavigateShoppingPage: 'customShoppingPageNavigation',
//     customNavigateCartPage: 'customCartPageNavigation'
//   },
// )

export default {
  name: 're-quick-cart',
  settings: 'element.quick-cart',
  translations: 'element.quick-cart',
  mixins: [
    ComponentMixin,
    CartMixin,
    ProductMixin,
    CartLocationMixin,
    ResponsiveMixin,
    // NextActionMixin
  ],
  props,
  data() {
    return {
      quickCartStep: null,
    }
  },
  computed: {
    showCartCount() {
      return this.$$getData('showCount')
    },
    visibleCartItemsCount() {
      return (_.reject(this.currentCartItems || {}, (i) => i.attributes.skipCartCount)).length
    },
    basicSubTotal() {
      return _.reduce(this.currentCartItems, (total, i) => {
        return total + this.getItemTotal(i)
      }, 0)
    },
    isEmptyCartView() {
      return this.currentCartIsEmpty || this.quickCartStep === 'empty'
    },
    canShowItemImage() {
      return this.$$getData('showItemImage')
    },
    isCartLinkAction() {
      return !!this.$$getData('customCartPageNavigation')
    }
  },
  methods: {
    continueShopping() {
      if (this.customNavigateShoppingPage) {
        this.customNavigateShoppingPage()
      }
    },
    continueToCart() {
      if (this.customNavigateCartPage) {
        this.customNavigateCartPage()
      }
    },
    updateCartItemCount(count, cartItem){
      const item = _.cloneDeep(cartItem)
      _.set(item, 'payload.count', count)
      this.updateCartItem(item)
    },
    getItemProduct(cartItem) {
      return cartItem.attributes.product || {}
    },
    getItemTotal(cartItem) {
      const price = this.getProductItemProperty('price', 0, this.getItemProduct(cartItem))
      const count = cartItem.payload.count || 1
      return price * count
    },
    getItemProductImageSrc(cartItem) {
      return this.getProductImage(this.getItemProduct(cartItem))
    },
    getItemProductTitle(cartItem) {
      return this.getProductItemProperty('title', '', this.getItemProduct(cartItem))
    },
    setQuickCartStep(step) {
      this.quickCartStep = step
    },
    dismiss() {
      this.$emit('close')
      this.$emit('dismiss')
    }
  }
}
